import { render, staticRenderFns } from "./mStatisticCard.vue?vue&type=template&id=1bbd2fba&scoped=true"
import script from "./mStatisticCard.vue?vue&type=script&lang=ts"
export * from "./mStatisticCard.vue?vue&type=script&lang=ts"
import style0 from "./mStatisticCard.vue?vue&type=style&index=0&id=1bbd2fba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd2fba",
  null
  
)

export default component.exports